export var isPlatformReactNative = function () {
    return typeof navigator !== 'undefined' && (navigator === null || navigator === void 0 ? void 0 : navigator.product) === 'ReactNative';
};
export var isJSEngineHermes = function () { var _a; return !!((_a = global) === null || _a === void 0 ? void 0 : _a.HermesInternal); };
